import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import {
  Wallet,
  MessageCircle,
  FileText,
  X,
  Download,
  CheckCircleIcon,
  XCircleIcon,
  CalendarIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
} from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { decrypt, encrypt } from "../utils/cryptoUtils";
import { payouthistry } from "../redux/InitiatepayoutSlice";
import { makeAuthenticatedRequest, Report } from "../utils/api";
import { AxiosError } from "../components/sessionexpiry";
import { Todaypayouts, LastfunloadHistry } from "../redux/DashbordSlice"; // Corrected import
import { ToastContainer, toast } from "react-toastify";
import "./Dashboard.css";

// Add these imports at the top of your wallet.js file
import {
  ClockIcon,
  ArrowDownIcon,
  ArrowsRightLeftIcon,
  LockClosedIcon,
  ArrowPathIcon,
  MinusCircleIcon,
  PauseIcon,
  QuestionMarkCircleIcon,
  ArrowUturnLeftIcon,
  ArrowDownTrayIcon,
  MagnifyingGlassIcon,
  DocumentArrowDownIcon,
  EllipsisHorizontalIcon,
} from "@heroicons/react/20/solid"; // or 24/solid depending on version

const Payouts = () => {
  const [showModal, setShowModal] = useState(false);

  //const [showReportModal, setShowModal] = useState(false);
  const [showReportModal, setShowReportModal] = useState(false); // New state for report modal
  const [reportDate, setReportDate] = useState({
    startDate: new Date().toISOString().slice(0, 10),
    endDate: new Date().toISOString().slice(0, 10),
    status: "all",
  });
  const [status, setStatus] = useState("all");

  const [isGeneratingReport, setIsGeneratingReport] = useState(false);

  const [form, setForm] = useState({
    name: "",
    number: "",
    email: "",
    location: "",
    number2: "",
    ifsc: "",
    bank: "",
    amount: "",
    remarks: "",
    mode: "IMPS",
  });

  const allFilled = Object.values(form).every((v) => v.trim() !== "");

  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const limit = 10;
  const offset = (currentPage - 1) * limit;

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const merchantData = useSelector((state) => state.Initiatepayout.payoutlist);

  const users = JSON.parse(sessionStorage.getItem("users"));
  const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const fetchData = async () => {
    try {
      const whereClause = [
        {
          column: "mid",
          operator: "=",
          value: user_id,
        },
      ];

      if (status != "all") {
        whereClause.push({
          column: "response",
          operator: "=",
          value: status,
        });
      }

      const requestData = JSON.stringify({
        Dname: "collection",
        Tname: "collections",
        Cname: [
          "order_id",
          "reference_id",
          "email",
          "mobile",
          "amount",
          "markup",
          "gst",
          "total_fee",
          "narration",
          "transactionId",
          "transaction_reference",
          "response",
          "CONVERT_TZ(created_at, @@session.time_zone, '+05:30') as created_at",
        ],
        Where: whereClause,
        Order: { id: "desc" },
        Search: searchTerm,
        Limit: `${limit}`,
        Offset: `${offset}`,
      });

      const encrypted = encrypt(requestData);
      const data = await makeAuthenticatedRequest("POST", "/fetch", {
        encrypted,
      });
      const decryptdata = decrypt(data);
      const fixedString = decryptdata.replace(/\\"/g, '"');
      const jsonArray = JSON.parse(fixedString);
      setTotalCount(jsonArray[0].TotalCount);
      dispatch(payouthistry(jsonArray));
    } catch (err) {
      setError(
        "Failed to fetch data: " + (err.response?.data?.message || err.message)
      );
    }
  };

  useEffect(() => {
    //fetchData();
  }, [searchTerm, currentPage, status]);

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPage(1); // Reset to first page when new search happens
  };

  const goToNextPage = () => setCurrentPage((prev) => prev + 1);
  const goToPrevPage = () =>
    setCurrentPage((prev) => (prev > 1 ? prev - 1 : 1));

  const totalPages = Math.ceil(totalCount / limit); // Calculate total pages

  const lastpayouts =
    merchantData && merchantData.length > 0 ? merchantData : [];

  /////// Balance //////////

  //const users = JSON.parse(sessionStorage.getItem("users"));
  //const user_id = users?.userdatils?.kycs_step ? users.userdatils.user_id : "0";

  const Todaypayoutsdetailes = useSelector((state) => state.Dashboard.today);
  const fund_history = useSelector((state) => state.Dashboard.fundloads);

  const [profileData, setProfileData] = useState({
    balance: "0.00",
  });

  // useEffect(() => {
  //   const payout_balance = async () => {
  //     try {
  //       const requestData = JSON.stringify({
  //         Dname: "collection",
  //         Tname: "merchants m",
  //         Cname: ["balance"],
  //         Where: [
  //           {
  //             column: "m.mid",
  //             operator: "=",
  //             value: user_id,
  //           },
  //         ],
  //         Limit: "10",
  //         Offset: "0",
  //       });

  //       const encrypted = encrypt(requestData);
  //       const data = await makeAuthenticatedRequest(
  //         "POST",
  //         "/fetch",
  //         { encrypted },
  //         navigate
  //       );

  //       const decryptdata = decrypt(data);
  //       const fixedString = decryptdata.replace(/\\"/g, '"');
  //       const jsonArray = JSON.parse(fixedString);

  //       if (jsonArray.length > 1) {
  //         setProfileData({
  //           balance: jsonArray[1].balance || "0.00",
            
  //         });
  //       }
  //     } catch (err) {
  //       setError(err.message);
  //       AxiosError(navigate, err);
  //     }
  //   };
  //   payout_balance();

  //   const todatpayout = async () => {
  //     const dateOnly = new Date().toISOString().slice(0, 10);

  //     try {
  //       const requestData = JSON.stringify({
  //         Dname: "collection",
  //         Tname: "collections",
  //         Cname: [
  //           "response",
  //           "count(*) as count",
  //           "sum(amount) as amount",
  //           "ROUND(SUM(CASE WHEN response = 'success' THEN 1 ELSE 0 END) * 100.0 / COUNT(*), 2) as success_ratio",
  //         ],
  //         Where: [
  //           {
  //             column: "mid",
  //             operator: "=",
  //             value: user_id,
  //           },
  //           {
  //             column: "date(created_at)",
  //             operator: "=",
  //             value: dateOnly,
  //           },
  //         ],
  //         GroupBy: ["response"],
  //         Limit: "10",
  //         Offset: "0",
  //       });

  //       const encrypted = encrypt(requestData);
  //       const data = await makeAuthenticatedRequest(
  //         "POST",
  //         "/fetch",
  //         { encrypted },
  //         navigate
  //       );

  //       const decryptdata = decrypt(data);
  //       const fixedString = decryptdata.replace(/\\"/g, '"');
  //       const jsonArray = JSON.parse(fixedString);

  //       dispatch(Todaypayouts(jsonArray)); // Pass the entire response
  //     } catch (err) {
  //       setError(err.message);
  //       AxiosError(navigate, err);
  //     }
  //   };
  //   //todatpayout();
  //   //fundloads();
  //   //fetchAccountStatus();
  // }, [dispatch, user_id, navigate]);

  const success =
    Todaypayoutsdetailes && Todaypayoutsdetailes.length > 0
      ? Todaypayoutsdetailes.filter((item) => item.response === "SUCCESS")
      : [];

  //console.log("success", success);
  const pending =
    Todaypayoutsdetailes && Todaypayoutsdetailes.length > 0
      ? Todaypayoutsdetailes.filter((item) => item.response === "PENDING")
      : [];

  const fundLoadHistory =
    fund_history && fund_history.length > 0 ? fund_history : [];

  //const [date, setDate] = useState();

  //console.log("date", Date);
  //console.log("reportDate", user_id);

  const PayoutDownload = async () => {
    try {
      const startDate = reportDate.startDate;
      const endDate = reportDate.endDate;
      const status = reportDate.status;

      let url = `/payouts/by-date/download?fromDate=${startDate}&toDate=${endDate}&mid=${user_id}&type=csv`;

      // ✅ only add status if user selected something (not "all" or empty)
      if (status && status !== "all") {
        url += `&status=${status}`;
      }

      const response = await Report("GET", url, navigate);

      const blob = response.data;

      const text = await blob.text();
      console.log("CSV Content Preview:", text.slice(0, 200)); // Just a preview

      // 🔍 Try to extract filename from headers (if backend sends it)
      const contentDisposition = response.headers["content-disposition"];
      let filename = `payout_report_${startDate}_To_${endDate}_Status_${status}.csv`;

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match?.[1]) {
          filename = match[1];
        }
      }

      // 🔻 Start file download
      const downloadUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

      toast.success("Report downloaded successfully!");
    } catch (err) {
      console.error("Download Error:", err);
      setError(err.message);
      AxiosError(navigate, err);
    }
  };

  return (
    <main className="main-content animate-fade-in-up mesh-bg min-h-screen relative overflow-hidden overflow-y-hidden w-[1195px]">
      {/* Decorative Orbs */}
      <div className="color-orb-1 top-[-100px] left-[-50px]"></div>
      <div className="color-orb-2 top-[300px] right-[-50px]"></div>

     {/* Header */}
           <div className="mb-6 flex flex-col md:flex-row md:items-center md:justify-between bg-gradient-to-r from-indigo-900 via-indigo-950 to-slate-950 rounded-3xl px-8 py-6 shadow-xl relative overflow-hidden border border-slate-900 animate-fade-in-up">
             {/* Ambient light leaks inside header */}
             <div className="absolute -top-12 -left-12 w-48 h-48 bg-indigo-500/10 rounded-full blur-3xl pointer-events-none" />
             <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-purple-500/10 rounded-full blur-3xl pointer-events-none" />
     
             <div className="relative z-10">
               <h2 className="text-3xl font-extrabold text-white tracking-tight flex items-center gap-2">
                 <span>Settlement Console</span>
                 <span
                   className={`text-xs px-2.5 py-0.5 rounded-full font-bold uppercase tracking-wider border ${
                     profileData.status === "1"
                       ? "bg-indigo-500/25 border-indigo-500/35 text-indigo-300 animate-pulse"
                       : "bg-rose-500/20 border-rose-500/30 text-rose-300"
                   }`}
                 >
                   {profileData.status === "1" ? "Active" : "Inactive"}
                 </span>
               </h2>
               <p className="text-indigo-200/80 text-sm mt-1.5 font-medium">
                  View settlement history, track settlement status, and download detailed settlement reports for your transactions.


               </p>
             </div>
             <nav className="mt-4 md:mt-0 relative z-10">
               <ol className="flex items-center space-x-2 text-xs font-semibold">
                 <li>
                   <Link
                     to="/dashboard"
                     className="flex items-center gap-1.5 py-2 px-3 bg-white/5 hover:bg-white/10 rounded-xl text-indigo-200 hover:text-white transition duration-200 border border-white/5"
                   >
                     <span className="material-icons text-sm">dashboard</span>
                     <span>Console</span>
                   </Link>
                 </li>
                 <li className="text-indigo-400">/</li>
                 <li className="text-indigo-300/60 font-normal">Settlement</li>
               </ol>
             </nav>
           </div>

      {/* Cards */}
     
      {/* Table Container */}
      <div className="mx-auto relative z-10 animate-fade-in-up">
        <div className="glass-panel rounded-3xl border border-slate-100/80 shadow-lg overflow-hidden bg-white/70 backdrop-blur-md">
          
          {/* Controls Bar */}
          <div className="px-6 py-5 border-b border-slate-100">
            <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
              
              {/* Left Filters */}
              <div className="flex flex-col sm:flex-row items-center gap-3 w-full lg:w-auto">
                {/* Search Bar */}
                <div className="relative w-full sm:w-72">
                  <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                    <MagnifyingGlassIcon className="h-4 w-4 text-slate-400" />
                  </div>
                  <input
                    type="text"
                    placeholder="Search transactions..."
                    className="premium-input pl-10 pr-4 py-2.5 w-full rounded-2xl text-slate-700 placeholder-slate-400 text-sm focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 border border-slate-200/80 bg-white/90"
                    value={searchTerm}
                    onChange={handleSearchChange}
                  />
                </div>

                {/* Status Dropdown */}
                <div className="relative w-full sm:w-52">
                  <div className="absolute inset-y-0 right-0 pr-3.5 flex items-center pointer-events-none">
                    <ChevronDownIcon className="h-4 w-4 text-slate-400" />
                  </div>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="premium-input px-4 py-2.5 w-full rounded-2xl text-slate-700 text-sm appearance-none border border-slate-200/80 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 bg-white/90"
                  >
                    <option value="all">All Statuses</option>
                    <option value="initiated">Initiated</option>
                    <option value="Pending">Pending</option>
                    <option value="success">Success</option>
                    <option value="refunded">Refunded</option>
                    <option value="failed">Failed</option>
                  </select>
                </div>

                {/* Generate Report Button */}
                <button
                  onClick={() => setShowReportModal(true)}
                  className="w-full sm:w-auto flex items-center justify-center gap-2 bg-gradient-to-r from-indigo-650 to-violet-650 text-white px-5 py-2.5 rounded-2xl text-sm font-bold transition-all duration-300 hover:shadow-lg hover:shadow-indigo-500/10 active:scale-[0.98] whitespace-nowrap shadow-sm"
                >
                  <DocumentArrowDownIcon className="w-4 h-4" />
                  Generate Report
                </button>
              </div>

              {/* Right Side: Pagination */}
              <div className="w-full lg:w-auto flex justify-center lg:justify-end">
                <div className="inline-flex rounded-2xl shadow-sm bg-slate-50/50 p-1 border border-slate-100">
                  <button
                    className="inline-flex items-center px-3.5 py-2 rounded-xl text-slate-600 hover:text-slate-900 text-xs font-bold transition duration-150 hover:bg-white disabled:opacity-40 disabled:hover:bg-transparent disabled:cursor-not-allowed"
                    onClick={goToPrevPage}
                    disabled={currentPage === 1}
                  >
                    <ChevronLeftIcon className="h-3.5 w-3.5 mr-1" />
                    Prev
                  </button>

                  <button
                    className={`inline-flex items-center justify-center w-8 h-8 rounded-xl text-xs font-bold transition-all ${
                      currentPage === 1
                        ? "bg-indigo-600 text-white shadow-sm"
                        : "text-slate-600 hover:bg-white"
                    }`}
                    onClick={() => setCurrentPage(1)}
                  >
                    1
                  </button>

                  {currentPage > 3 && (
                    <span className="inline-flex items-center px-1 text-slate-400">
                      <EllipsisHorizontalIcon className="h-4 w-4" />
                    </span>
                  )}

                  {[...Array(totalPages)]
                    .map((_, i) => i + 1)
                    .filter(
                      (page) =>
                        page > 1 &&
                        page < totalPages &&
                        Math.abs(page - currentPage) <= 1
                    )
                    .map((page) => (
                      <button
                        key={page}
                        className={`inline-flex items-center justify-center w-8 h-8 rounded-xl text-xs font-bold transition-all ${
                          currentPage === page
                            ? "bg-indigo-600 text-white shadow-sm"
                            : "text-slate-600 hover:bg-white"
                        }`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ))}

                  {currentPage < totalPages - 2 && (
                    <span className="inline-flex items-center px-1 text-slate-400">
                      <EllipsisHorizontalIcon className="h-4 w-4" />
                    </span>
                  )}

                  {totalPages > 1 && (
                    <button
                      className={`inline-flex items-center justify-center w-8 h-8 rounded-xl text-xs font-bold transition-all ${
                        currentPage === totalPages
                          ? "bg-indigo-600 text-white shadow-sm"
                          : "text-slate-600 hover:bg-white"
                      }`}
                      onClick={() => setCurrentPage(totalPages)}
                    >
                      {totalPages}
                    </button>
                  )}

                  <button
                    className="inline-flex items-center px-3.5 py-2 rounded-xl text-slate-600 hover:text-slate-900 text-xs font-bold transition duration-150 hover:bg-white disabled:opacity-40 disabled:hover:bg-transparent disabled:cursor-not-allowed"
                    onClick={goToNextPage}
                    disabled={currentPage === totalPages}
                  >
                    Next
                    <ChevronRightIcon className="h-3.5 w-3.5 ml-1" />
                  </button>
                </div>
              </div>

            </div>
          </div>

          {/* Table Section */}
          <div className="p-0">
            <div className="max-w-full overflow-x-auto">
              <table className="min-w-full border-collapse">
                <thead>
                  <tr className="text-slate-400 text-xs font-bold border-b border-slate-100 bg-slate-50/50 whitespace-nowrap text-center uppercase tracking-wider">
                    <th className="px-6 py-4">Sl.No</th>
                    <th className="px-6 py-4">Created On</th>
                    <th className="px-6 py-4">UTR</th>
                    <th className="px-6 py-4">Order ID</th>
                    <th className="px-6 py-4">Transaction ID</th>
                    <th className="px-6 py-4">Amount</th>
                    <th className="px-6 py-4">Charges</th>
                    <th className="px-6 py-4">GST</th>
                    <th className="px-6 py-4">Net Amount</th>
                    <th className="px-6 py-4">Status</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-slate-100">
                  {merchantData.slice(1).length > 0 ? (
                    merchantData.slice(1).map((payout, index) => (
                      <tr
                        key={payout.payout_id || index}
                        className="whitespace-nowrap text-center hover:bg-slate-50/30 transition-colors duration-150"
                      >
                        <td className="px-6 py-4">
                          <span className="text-slate-500 text-sm font-semibold">
                            {index + 1 + (currentPage - 1) * limit}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-slate-500 text-sm">
                            {new Date(payout.created_at).toLocaleString(
                              "en-IN",
                              {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              }
                            )}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-slate-600 text-sm font-mono bg-slate-50 px-2.5 py-1 rounded-lg border border-slate-100">
                            {payout.transaction_reference &&
                            payout.transaction_reference !== "null"
                              ? payout.transaction_reference
                              : "-"}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-slate-500 text-sm font-medium">
                            {payout.order_id || "-"}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-slate-500 text-sm font-mono">
                            {payout.transactionId || "-"}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-slate-800 text-sm font-extrabold">
                            ₹{payout.amount}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-slate-500 text-sm font-medium">
                            ₹{payout.markup}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-slate-500 text-sm font-medium">
                            ₹{payout.gst}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <span className="text-slate-700 text-sm font-bold">
                            ₹{payout.total_fee}
                          </span>
                        </td>
                        <td className="px-6 py-4">
                          <div className="flex items-center justify-center">
                            <span
                              className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-bold border transition-all ${
                                payout.response?.toUpperCase() === "SUCCESS"
                                  ? "bg-emerald-500/10 text-emerald-600 border-emerald-500/20"
                                  : payout.response?.toLowerCase() === "failed"
                                  ? "bg-rose-500/10 text-rose-600 border-rose-500/20"
                                  : payout.response?.toUpperCase() === "PENDING"
                                  ? "bg-amber-500/10 text-amber-600 border-amber-500/20"
                                  : payout.response?.toLowerCase() === "initiated"
                                  ? "bg-blue-500/10 text-blue-600 border-blue-500/20"
                                  : payout.response?.toLowerCase() === "refunded"
                                  ? "bg-purple-500/10 text-purple-600 border-purple-500/20"
                                  : "bg-slate-500/10 text-slate-600 border-slate-500/20"
                              }`}
                            >
                              {payout.response?.toUpperCase() === "SUCCESS" || payout.response?.toLowerCase() === "success" ? (
                                <CheckCircleIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.response?.toLowerCase() === "failed" ? (
                                <XCircleIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.response === "sent-for-processing" ? (
                                <ArrowPathIcon className="w-3.5 h-3.5 mr-1 animate-spin" />
                              ) : payout.response?.toLowerCase() === "initiated" ? (
                                <ClockIcon className="w-3.5 h-3.5 mr-1" />
                              ) : payout.response?.toLowerCase() === "refunded" ? (
                                <ArrowUturnLeftIcon className="w-3.5 h-3.5 mr-1" />
                              ) : (
                                <QuestionMarkCircleIcon className="w-3.5 h-3.5 mr-1" />
                              )}
                              {payout.response === "sent-for-processing"
                                ? "Sent for Processing"
                                : payout.response ? payout.response.charAt(0).toUpperCase() + payout.response.slice(1) : "-"}
                            </span>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan="10"
                        className="text-center py-10 text-slate-400 font-medium bg-slate-50/10"
                      >
                        <div className="flex flex-col items-center justify-center space-y-2">
                          <Wallet className="w-8 h-8 text-slate-300 animate-pulse" />
                          <span>No Settlements history found.</span>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>

          {showReportModal && (
            <div className="modal-backdrop-fixed">
              <div className="glass-modal w-full max-w-md rounded-3xl p-6 relative mx-4 animate-fade-in-up border border-white/60">
                <button
                  className="absolute top-5 right-5 text-slate-400 hover:text-slate-600 transition-colors p-1.5 hover:bg-slate-100/50 rounded-lg"
                  onClick={() => setShowReportModal(false)}
                >
                  <X className="w-5 h-5" />
                </button>

                <div className="space-y-1.5 mb-6">
                  <h2 className="text-xl font-extrabold text-slate-800">
                    Generate Report
                  </h2>
                  <p className="text-xs font-medium text-slate-400">
                    Select custom date range and filters to compile download
                  </p>
                </div>

                <div className="space-y-5">
                  {/* From Date */}
                  <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                      From Date
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        className="premium-input w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-white/90 text-sm text-slate-700 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
                        value={reportDate.startDate}
                        onChange={(e) =>
                          setReportDate({
                            ...reportDate,
                            startDate: e.target.value,
                          })
                        }
                        max={new Date().toISOString().slice(0, 10)}
                      />
                    </div>
                  </div>

                  {/* To Date */}
                  <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                      To Date
                    </label>
                    <div className="relative">
                      <input
                        type="date"
                        className="premium-input w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-white/90 text-sm text-slate-700 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500"
                        value={reportDate.endDate}
                        onChange={(e) =>
                          setReportDate({
                            ...reportDate,
                            endDate: e.target.value,
                          })
                        }
                        max={new Date().toISOString().slice(0, 10)}
                      />
                    </div>
                  </div>

                  {/* Status Selection */}
                  <div>
                    <label className="block text-xs font-bold text-slate-500 uppercase tracking-wider mb-2">
                      Status Filter
                    </label>
                    <div className="relative">
                      <select
                        className="premium-input w-full px-4 py-2.5 rounded-xl border border-slate-200 bg-white/90 text-sm text-slate-700 focus:ring-2 focus:ring-indigo-500/20 focus:border-indigo-500 appearance-none"
                        value={reportDate.status}
                        onChange={(e) =>
                          setReportDate({
                            ...reportDate,
                            status: e.target.value,
                          })
                        }
                      >
                        <option value="" disabled>
                          Select Status
                        </option>
                        <option value="success">Success</option>
                        <option value="failed">Failed</option>
                        <option value="refunded">Refunded</option>
                        <option value="sent-for-processing">
                          Sent for Processing
                        </option>
                      </select>
                      <ChevronDownIcon className="w-4 h-4 absolute right-4 top-3 text-slate-400 pointer-events-none" />
                    </div>
                  </div>

                  {/* Download Button */}
                  <button
                    onClick={PayoutDownload}
                    disabled={isGeneratingReport}
                    className={`mt-6 w-full px-5 py-3 rounded-2xl font-bold flex items-center justify-center space-x-2 transition-all duration-300 text-white ${
                      isGeneratingReport
                        ? "bg-indigo-400 cursor-not-allowed"
                        : "bg-indigo-600 hover:bg-indigo-700 shadow-md shadow-indigo-100 hover:shadow-lg active:scale-[0.98]"
                    }`}
                  >
                    {isGeneratingReport ? (
                      <>
                        <ArrowPathIcon className="w-5 h-5 animate-spin" />
                        <span>Generating Report...</span>
                      </>
                    ) : (
                      <>
                        <ArrowDownTrayIcon className="w-5 h-5" />
                        <span>Download Report</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          )}

          <ToastContainer position="top-right" autoClose={3000} />
        </div>
      </div>
    </main>
  );
};

export default Payouts;
